import fetch from 'utils/fetch';
import { Result, ResearchSheet, LabeledObject, Params } from 'types';
import { SortOrder } from 'enums';
import { useCachedFetch } from 'utils/use-cached-fetch';

const defaultStateSort = {
  field: 'state',
  order: SortOrder.ASC,
  datakey: 'state',
};

export async function fetchResearchSheets(
  defaultParams: Params = {}
): Promise<Result<ResearchSheet>> {
  const { sort = [] } = defaultParams;
  const params: Params = {
    ...defaultParams,
    sort: sort.some(({ field }) => field === 'state')
      ? sort
      : [defaultStateSort, ...sort],
  };

  const response = await fetch('/api/research-sheet/my-sheets', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params),
  });

  const json = await response.json();

  return json;
}

export async function switchCurrentlyUsedSheet(
  researchSheetId: string
): Promise<boolean> {
  await fetch(
    `/api/user/switch-currently-used-sheet?researchSheetId=${researchSheetId}`,
    {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }
  );

  return true;
}

export async function postResearchSheetNew(
  data: ResearchSheet
): Promise<ResearchSheet> {
  const response = await fetch('/api/research-sheet/new', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      ...data,
    }),
  });

  const json = await response.json();

  return json;
}

export async function putResearchSheetRework(
  data: ResearchSheet
): Promise<boolean> {
  const response = await fetch(`/api/research-sheet/${data.id}/rework`, {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      ...data,
    }),
  });

  return response.ok;
}

/**
 * Enum hook for fetching research sheet states.
 */
export function useResearchSheetStates() {
  return (
    useCachedFetch<LabeledObject[]>(
      '/api/research-sheet/research-sheet-states'
    ) || []
  );
}

export async function getResearchSheet(
  id?: string
): Promise<ResearchSheet | undefined> {
  try {
    if (!id) {
      return undefined;
    }

    const response = await fetch(`/api/research-sheet/${id}`, {
      method: 'GET',
    });

    const sheet: ResearchSheet = await response.json();
    return sheet;
  } catch (e) {
    console.log(e);
    return undefined;
  }
}

export async function widthdrawRemoteAccess(
  sheetId: string
): Promise<{
  ok: boolean;
  data?: any;
}> {
  try {
    await fetch(
      `/api/research-sheet/${sheetId}/update-remote-access?remoteAccess=${false}`,
      {
        method: 'PUT',
      }
    );
    return {
      ok: true,
    };
  } catch (e) {
    return {
      ok: true,
      data: e,
    };
  }
}

export async function grantRemoteAccess(
  sheetId: string
): Promise<{
  ok: boolean;
  data?: any;
}> {
  try {
    await fetch(
      `/api/research-sheet/${sheetId}/update-remote-access?remoteAccess=${true}`,
      {
        method: 'PUT',
      }
    );
    return {
      ok: true,
    };
  } catch (e) {
    console.log(e);

    return {
      ok: true,
      data: e,
    };
  }
}
